<template>
  <div v-loading="isLoading">
    <div
      v-for="(event, index) in events"
      :key="event.id"
    >
      <EventNotes
        :event="event"
        class="mb-3"
      />
      <span class="text-muted">{{ $_.get(event, 'type.name', '-') }}, {{ $_.get(event, 'completed_at') ? $moment($_.get(event, 'completed_at')).fromNow() : `Due at: ${$moment($_.get(event, 'due_at', '-')).fromNow()}` }}</span>
      <el-divider v-if="index !== events.length - 1" />
    </div>
    <el-pagination
      class="text-center pt-3"
      :current-page.sync="events.page"
      :page-size.sync="events.limit"
      layout="prev, pager, next"
      :total="events.total"
      @size-change="reload"
      @current-change="reload"
    />
  </div>
</template>

<script>
import EventNotes from '@/components/Application/Sales/Opportunities/Opportunity/Peek/EventNotes'
import { CREATED, UPDATED, DELETED, RESTORED } from '@/plugins/sdk/Events'

export default {
  components: {
    EventNotes
  },
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      events: [],
      isLoading: true
    }
  },
  created () {
    this.loadEvents()
  },
  mounted () {
    this
      .$sdk
      .account_event
      .on([ CREATED, UPDATED, DELETED, RESTORED ], this.reload, this)
  },
  methods: {
    loadEvents () {
      this.isLoading = true
      this.$sdk.account_event.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.include = 'type'
        builder.limit = 3
        builder.order = 'created_at:desc'
      }).then(res => {
        this.events = res
      }).finally(() => { this.isLoading = false })
    },
    async reload () {
      this.isLoading = true

      await this.events.reload()

      this.isLoading = false
    }
  }
}
</script>

<style></style>
